import { call, put, takeLatest } from "@redux-saga/core/effects";
import { NetworkTableApi } from "./NetworkTableApi";
import { NetworkTableconstant } from "./NetworkTableConstant";
import { NetworkTableParser } from "./NetworkTableParser";

function* getNetworktable({payload}) {
  
  let { from_date, to_date, search_term, page, limit } = payload;
  try {
    yield put({ type: NetworkTableconstant.NETWORK_TABLE_REQUEST });

    const res = yield call(NetworkTableApi.getNetworkTable, {
      to_date,
      from_date,
      search_term,
      page,
      limit,
    });

 NetworkTableParser.getNetworkTableParser(res);

    yield put({
      type: NetworkTableconstant.NETWORK_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: NetworkTableconstant.NETWORK_TABLE_RESPONSE,
      payload: [],
    });
  }
}

// ************post********

function* postAddChargingNetworklSaga(payload) {


  try {
    yield put({ type: NetworkTableconstant.POST_ADD_CHARGING_NETWORK_REQUEST });

    const res = yield call(NetworkTableApi.postChargingNetworkApi, payload);

    yield put({
      type: NetworkTableconstant.POST_ADD_CHARGING_NETWORK_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: NetworkTableconstant.POST_ADD_CHARGING_NETWORK_RESPONSE,
      payload: [],
    });
  }
}

//enable desable charging network

function* AddChargingNetworkEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({
      type: NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_REQUEST,
    });
    const res = yield call(NetworkTableApi.AddChargingNetworkEnableDisableApi, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_RESPONSE,
      payload: [],
    });
  }
}

//update charging network

function* UpdateChargingNetworkSaga(payload) {
  try {
    yield put({ type: NetworkTableconstant.UPDATE_CHARGING_NETWORK_REQUEST });

    const res = yield call(NetworkTableApi.UpdateChargingNetworkApi, payload);


    yield put({
      type: NetworkTableconstant.UPDATE_CHARGING_NETWORK_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: NetworkTableconstant.UPDATE_CHARGING_NETWORK_RESPONSE,
      payload: [],
    });
  }
}

export function* registerNetworktableSaga() {
  yield takeLatest(NetworkTableconstant.NETWORK_TABLE_SAGA, getNetworktable);
  yield takeLatest(
    NetworkTableconstant.POST_ADD_CHARGING_NETWORK_SAGA,
    postAddChargingNetworklSaga
  );
  yield takeLatest(
    NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_SAGA,
    AddChargingNetworkEnableDisable
  );
  yield takeLatest(
    NetworkTableconstant.UPDATE_CHARGING_NETWORK_SAGA,
    UpdateChargingNetworkSaga
  );
}
